import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import classnames from 'classnames';
import { PureButton } from '../../basics';
import { ChevronIcon } from '../Icons';
import { AccordionContext, isAccordionItemSelected, } from './AccordionContext';
import { AccordionItemContext } from './AccordionItemContext';
import styles from './AccordionItem.module.scss';
function useAccordionButton(itemId, onClick) {
    const { activeItemId, autoClose, onSelect, setActiveItemId } = useContext(AccordionContext);
    return e => {
        /*
        Compare the item id in context with the given item id.
        If they are the same, then collapse the component.
      */
        let itemIdPassed = itemId === activeItemId ? null : itemId;
        if (!autoClose) {
            if (Array.isArray(activeItemId)) {
                if (activeItemId.includes(itemId)) {
                    itemIdPassed = activeItemId.filter(k => k !== itemId);
                }
                else {
                    itemIdPassed = [...activeItemId, itemId];
                }
            }
            else {
                // activeItemId is undefined.
                itemIdPassed = [itemId];
            }
        }
        const isActive = isAccordionItemSelected(itemIdPassed, itemId);
        setActiveItemId(itemIdPassed);
        onSelect?.(itemId, isActive);
        onClick?.(e);
    };
}
const AccordionButton = ({ isDisabled = false, onClick, onIconClick, title, }) => {
    const { id } = useContext(AccordionItemContext);
    const accordionOnClick = useAccordionButton(id, onClick);
    const { activeItemId } = useContext(AccordionContext);
    return (_jsxs(PureButton, { id: `${id}Button`, "aria-controls": id, "aria-expanded": Array.isArray(activeItemId) ? activeItemId.includes(id) : id === activeItemId, className: classnames(styles.heading, 'd-flex align-items-start justify-content-start m-0 border-0 pt-1-5x w-100'), onClick: accordionOnClick, disabled: isDisabled, children: [_jsx("div", { className: classnames(styles.title, 'w-100 pr-0-5x'), children: title }), _jsx(ChevronIcon, { className: classnames(styles.icon, 'mr-0-5x'), onClick: onIconClick })] }));
};
export { AccordionButton };
